import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import styles from './validDeleteAccessibilityDialog.module.scss'
import { useMutation } from '@apollo/client'
import { Close, Delete } from '@mui/icons-material'
import { DELETE_DAYCARE_ACCESSIBILITY } from '@/modules/API/daycare/daycareAccessibilityHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ValidDeleteAccessProps {
    open: boolean
    handleClose: () => void
    accessibilityId: number
    removeOneAccessibility: (accessibilityId: number) => void
}

const ValidDeleteAccessibilityDialog: FunctionComponent<ValidDeleteAccessProps> = ({
    open,
    handleClose,
    accessibilityId,
    removeOneAccessibility
}: ValidDeleteAccessProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneAccessibility] = useMutation(DELETE_DAYCARE_ACCESSIBILITY, {
        variables: {
            accessibility_id: Number(accessibilityId)
        },
        onCompleted: () => {
            showNotificationSuccess(t('accessibilityDeleted'))

            removeOneAccessibility(accessibilityId)

            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedAccessibility'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmDeleteAccessibility')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteAccessibilityMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Delete />}
                        customText={t('yes')}
                        onClick={deleteOneAccessibility}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customIcon={<Close />}
                        customText={t('no')}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeleteAccessibilityDialog
